import React, { Component } from "react";
import ClearFilterButton from "../../components/ClearFilterButton.js";
import { loading, alert, NavbarAdmin, Pagination, DateRangeFields, Select, Modal, GET, GET_FILE, saveAs, profile, t } from "../../components/CustomComponent.js";
import { toDateOnly, currentWeekRange, rangeDays, fmtDate, pruneParams, hasPermission } from "../../utils/timeTracking.js";
import "../../assets/css/time-tracking.css";
import { formatNumber } from "../../utils/formatting";

const Q_DEBOUNCE_MS = 400;
// ช่วงวันที่สูงสุดที่ backend รับ (รวมวันแรกและวันสุดท้าย)
const MAX_RANGE_DAYS = 31;
const PAGE_SIZES = [15, 50, 100];
const PAYMENTS = [
  { key: "cash", color: "#1F8A4C" },
  { key: "transfer", color: "#3557DB" },
  { key: "cheque", color: "#7A4FD6" },
  { key: "bill", color: "#B86E0A" },
];
const PAY_COLOR = Object.fromEntries(PAYMENTS.map((p) => [p.key, p.color]));

// หัวคอลัมน์ 13 คอลัมน์ตามลำดับ A-M ของไฟล์ Excel: [field ที่ใช้ sort, key แปลภาษา, ชิดขวา]
const COLUMNS = [
  ["project_id", "nsp_col_project_id"],
  ["project_name", "nsp_col_project_name"],
  ["customer_id", "nsp_col_customer_id"],
  ["customer_name", "nsp_col_customer_name"],
  ["wo_number", "nsp_col_wo"],
  [null, "nsp_col_status"],
  [null, "nsp_col_technician"],
  ["payment_type", "nsp_col_payment"],
  ["amount", "nsp_col_amount", true],
  ["work_date", "nsp_col_date"],
  ["department", "nsp_col_bu"],
  ["so_no", "nsp_col_so"],
  ["invoice_no", "nsp_col_invoice"],
  [null, "nsp_col_photos"],
  [null, "nsp_col_sr"],
];
const PHOTO_STAGES = ["before", "during", "after"];

const money = (n) => Number(n || 0).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
const stamp = (d) => String(d || "").replace(/-/g, "");
const fmtNow = () => {
  const d = new Date();
  const p = (n) => String(n).padStart(2, "0");
  return `${p(d.getDate())}/${p(d.getMonth() + 1)}/${d.getFullYear()} ${p(d.getHours())}:${p(d.getMinutes())}`;
};

// หน้า "สรุปงานเสร็จ / การชำระเงิน - Normal Sales" ดูอย่างเดียว + Export xlsx
// field ตรงกับ SNAPA-Backend modules/admin/normal-sales-payment-report
//   GET admin/report/normal-sales-payment        -> data={rows,kpi,summary,technicians,department_options,locked_bu} + pagination (1 แถว = 1 visit)
//   GET admin/report/normal-sales-payment/export -> xlsx (GET_FILE เพราะเป็น binary) ตัวกรองเดียวกัน + summary=1/0
export default class AdminNormalSalesPaymentReport extends Component {
  constructor(props) {
    super(props);
    const today = toDateOnly(new Date());
    this.canExport = hasPermission(profile, "normal_sales_payment_report.export");
    this.q_timer = null;
    this.state = {
      filter_from: today,
      filter_to: today,
      filter_department: "",
      filter_pay: "",
      filter_technician: "",
      filter_q: "",
      preset: "today",
      sort: "work_date",
      dir: "asc",
      page: 1,
      size: PAGE_SIZES[0],

      rows: [],
      kpi: null,
      summary: null,
      technicians: [],
      department_options: [],
      locked_bu: "",
      count: 0,
      loaded: false,
      as_of: "",
      range_error: "",
      open_names: {},

      detail: null, // แถวที่เปิด drawer
      photo_modal: null, // { row, loading, photos:[{uid,stage,file_name,url}], failed }
      export_open: false,
      export_summary: true,
    };
  }

  componentDidMount() {
    loading(false);
    this.Get(1);
  }

  componentWillUnmount() {
    this.unmounted = true;
    this.photoReqId += 1; // ผลของคำขอรูปที่ยังค้างอยู่จะถูกทิ้งและ revoke เอง
    clearTimeout(this.q_timer);
    // pdfWatchers ปล่อยทำงานต่อหลังออกจากหน้า: แท็บ PDF ที่ผู้ใช้เปิดค้างไว้ยังต้องใช้ blob URL จนกว่าจะปิดแท็บ
    this.revokePhotoUrls(this.state.photo_modal);
  }

  photoReqId = 0; // ตัวนับคำขอรูป: ผลที่กลับมาไม่ตรงรอบล่าสุดถูกทิ้ง
  unmounted = false;

  revokePhotoUrls = (modal) => (modal?.photos || []).forEach((p) => p.url && URL.revokeObjectURL(p.url));

  // รูปของ visit: ขอรายการจาก backend แล้วโหลดไฟล์ผ่าน admin/attachments/:uid เป็น blob URL (ห้ามใช้ S3 URL ตรง)
  OpenPhotos = async (row) => {
    const reqId = ++this.photoReqId;
    this.revokePhotoUrls(this.state.photo_modal);
    this.setState({ photo_modal: { row, loading: true, photos: [], failed: 0 } });
    const result = await GET(`admin/report/normal-sales-payment/visits/${row.visit_uid}/photos`);
    const list = result?.status && result.data ? result.data.photos || [] : [];
    const photos = await Promise.all(
      list.map(async (p) => {
        const file = await GET_FILE(`admin/attachments/${p.uid}`);
        return { ...p, url: file?.status && file.blob ? URL.createObjectURL(file.blob) : "" };
      })
    );
    // ผู้ใช้ปิด/เปิดแถวเดิมซ้ำ/แถวอื่น หรือออกจากหน้าระหว่างโหลด -> ทิ้งผลของรอบนี้
    if (this.unmounted || reqId !== this.photoReqId) {
      this.revokePhotoUrls({ photos });
      return;
    }
    this.setState({ photo_modal: { row, loading: false, photos, failed: photos.filter((p) => !p.url).length } });
  };

  ClosePhotos = () => {
    this.photoReqId += 1; // ปิดระหว่างโหลด -> ผลที่มาช้าถูกทิ้ง
    this.revokePhotoUrls(this.state.photo_modal);
    this.setState({ photo_modal: null });
  };

  // เปิด Service Report PDF ของ visit - แบบเดียวกับ viewServiceReport ใน work-orders.js (เปิดแท็บตอนกดปุ่ม ก่อน await)
  OpenServiceReport = async (row) => {
    const viewerWindow = window.open("", "_blank");
    if (!viewerWindow) {
      alert("", "warning", t("warning"), t("service_report_popup_blocked"));
      return;
    }
    viewerWindow.document.write(`<!DOCTYPE html><html><head><meta charset="utf-8"><title>Service Report</title></head><body>${t("service_report_loading")}</body></html>`);
    loading(true);
    try {
      const result = await GET_FILE(`admin/work-orders/${row.wo_uid}/visits/${row.visit_uid}/service-report/pdf`);
      if (result?.status !== true || !result.blob) {
        viewerWindow.close();
        alert("", "warning", t("warning"), result?.message || t("service_report_unavailable"));
        return;
      }
      const blobUrl = URL.createObjectURL(result.blob);
      const viewerName = String(result.fileName || "service-report.pdf").replace(/[^A-Za-z0-9._-]/g, "_");
      viewerWindow.document.open();
      viewerWindow.document.write(
        `<!DOCTYPE html><html><head><meta charset="utf-8"><title>${viewerName}</title></head>` +
          `<body style="margin:0;display:flex;flex-direction:column;height:100vh;font-family:sans-serif">` +
          `<div style="padding:6px 12px;background:#f1f1f1;font-size:14px"><a href="${blobUrl}" download="${viewerName}">${viewerName}</a></div>` +
          `<iframe src="${blobUrl}" style="flex:1;border:0;width:100%"></iframe></body></html>`
      );
      viewerWindow.document.close();
      // revoke เมื่อแท็บที่เปิดอยู่ถูกปิดแล้วเท่านั้น (revoke ตามเวลาจะทำให้ PDF/ปุ่มดาวน์โหลดในแท็บเสีย)
      const timer = setInterval(() => {
        if (!viewerWindow.closed) return;
        clearInterval(timer);
        URL.revokeObjectURL(blobUrl);
      }, 5000);
    } finally {
      loading(false);
    }
  };

  buildParams = () => {
    const { filter_from, filter_to, filter_department, filter_pay, filter_technician, filter_q } = this.state;
    return pruneParams({
      from: filter_from,
      to: filter_to,
      department_uid: filter_department,
      pay_type: filter_pay,
      technician_uid: filter_technician,
      q: filter_q.trim(),
    });
  };

  // ข้อความ error ของช่วงวันที่ ("" = ใช้ได้) - ไม่ดึงข้อมูลถ้าไม่ผ่าน
  validateRange = () => {
    const { filter_from, filter_to } = this.state;
    if (!filter_from || !filter_to) return t("att_range_required");
    if (filter_from > filter_to) return t("att_range_order");
    if (rangeDays(filter_from, filter_to) > MAX_RANGE_DAYS) return t("ts_range_too_long");
    return "";
  };

  Get = async (page = 1) => {
    const range_error = this.validateRange();
    this.setState({ range_error });
    if (range_error) {
      this.setState({ rows: [], kpi: null, summary: null, count: 0, loaded: true });
      return;
    }
    const { sort, dir, size } = this.state;
    loading(true);
    const result = await GET("admin/report/normal-sales-payment", { ...this.buildParams(), sort, dir, page, limit: size });
    const ok = result?.status && result.data;
    const rows = ok ? result.data.rows || [] : [];
    this.setState({
      rows,
      kpi: ok ? result.data.kpi || null : null,
      summary: ok ? result.data.summary || null : null,
      technicians: ok ? result.data.technicians || [] : this.state.technicians,
      department_options: ok ? result.data.department_options || [] : this.state.department_options,
      // ผู้ใช้ที่ตั้ง BU ไว้: backend บังคับกรอง BU นี้เสมอ (ใช้ร่วมกับตัวกรองแผนก) หน้าเว็บแค่แสดงให้รู้
      locked_bu: ok ? result.data.locked_bu || "" : this.state.locked_bu,
      count: result?.pagination?.count ?? rows.length,
      page,
      loaded: true,
      as_of: fmtNow(),
      detail: null,
    });
    loading(false);
  };

  departmentLabel = (d) => [d.code, d.name].filter(Boolean).join(" ");

  SetFilter = (patch) => this.setState(patch, () => this.Get(1));

  SetQ = (value) => {
    this.setState({ filter_q: value });
    clearTimeout(this.q_timer);
    this.q_timer = setTimeout(() => this.Get(1), Q_DEBOUNCE_MS);
  };

  ApplyPreset = (key) => {
    const today = new Date();
    let from = new Date(today);
    if (key === "yest") from.setDate(today.getDate() - 1);
    if (key === "week") from = new Date(currentWeekRange().from + "T00:00:00");
    if (key === "month") from = new Date(today.getFullYear(), today.getMonth(), 1);
    const to = key === "yest" ? from : today;
    this.SetFilter({ filter_from: toDateOnly(from), filter_to: toDateOnly(to), preset: key });
  };

  ResetFilter = () => {
    const today = toDateOnly(new Date());
    this.SetFilter({ filter_from: today, filter_to: today, preset: "today", filter_department: "", filter_pay: "", filter_technician: "", filter_q: "" });
  };

  SortBy = (field) => {
    if (!field) return;
    const { sort, dir } = this.state;
    this.SetFilter({ sort: field, dir: sort === field && dir === "asc" ? "desc" : "asc" });
  };

  TogglePay = (key) => this.SetFilter({ filter_pay: this.state.filter_pay === key ? "" : key });

  OpenExport = () => {
    if (this.validateRange()) return;
    this.setState({ export_open: true });
  };

  Export = async () => {
    const { filter_from, filter_to, export_summary } = this.state;
    loading(true);
    const result = await GET_FILE("admin/report/normal-sales-payment/export", { ...this.buildParams(), summary: export_summary ? 1 : 0 });
    loading(false);
    if (result?.status && result.blob) {
      saveAs(result.blob, `NormalSales_Payment_${stamp(filter_from)}-${stamp(filter_to)}.xlsx`);
      this.setState({ export_open: false });
    } else {
      alert("", "warning", t("warning"), result?.message || t("nsp_export_failed"));
    }
  };

  // ---------------------------------------------------------------- render
  payLabel = (key) => t(`nsp_pay_${key}`);

  renderPay = (row) =>
    row.payment_type ? (
      <span className="d-inline-flex align-items-center gap-1" style={{ fontWeight: 500 }}>
        <i style={{ width: 9, height: 9, borderRadius: "50%", background: PAY_COLOR[row.payment_type], display: "inline-block" }} />
        {this.payLabel(row.payment_type)}
      </span>
    ) : (
      <span className="text-secondary">-</span>
    );

  renderInvoice = (row) => {
    if (row.invoice_status === "issued") return <span className="tt-mono">{row.invoice_no}</span>;
    if (row.invoice_status === "pending") return <span className="tt-badge tt-b-warn">{t("nsp_invoice_pending")}</span>;
    return <span className="tt-mini">{t("nsp_invoice_none")}</span>;
  };

  renderTechnician = (row) => {
    const names = row.technicians || [];
    if (!names.length) return <span className="text-secondary">-</span>;
    if (names.length === 1) return names[0];
    return (
      <>
        {names[0]} <b className="tt-mini" style={{ color: "var(--tt-brand)" }} title={names.join(", ")}>+{names.length - 1}</b>
      </>
    );
  };

  renderKpi() {
    const { kpi, filter_pay } = this.state;
    if (!kpi) return null;
    const total = kpi.total.amount;
    return (
      <div className="tt-kpis">
        <div className="tt-kpi static" data-testid="nsp-kpi-total">
          <small>{t("nsp_total_amount")}</small>
          <b className="tt-mono" style={{ color: "var(--tt-action)" }}>{money(total)}</b>
          <small>{formatNumber(kpi.total.wo_count)} {t("nsp_jobs")} · {formatNumber(kpi.total.line_count)} {t("nsp_lines")}</small>
        </div>
        {kpi.by_pay.map((p) => (
          <div
            key={p.key}
            className={`tt-kpi ${filter_pay === p.key ? "sel" : ""}`}
            style={p.line_count ? undefined : { opacity: 0.45 }}
            onClick={() => this.TogglePay(p.key)}
            data-testid={`nsp-kpi-${p.key}`}
          >
            <small className="d-flex align-items-center gap-1">
              <i style={{ width: 9, height: 9, borderRadius: "50%", background: PAY_COLOR[p.key], display: "inline-block" }} />
              {this.payLabel(p.key)}
            </small>
            <b className="tt-mono">{money(p.amount)}</b>
            <small>{formatNumber(p.wo_count)} {t("nsp_jobs")}{total && p.line_count ? ` · ${Math.round((p.amount / total) * 100)}%` : ""}</small>
          </div>
        ))}
      </div>
    );
  }

  renderRows() {
    const { rows, summary, sort, dir, open_names, range_error, loaded, count, size } = this.state;
    const head = (
      <thead>
        <tr>
          {COLUMNS.map(([field, key, right]) => (
            <th key={key} className={right ? "num" : ""} style={field ? { cursor: "pointer" } : undefined} onClick={() => this.SortBy(field)}>
              {t(key)} {field ? <span style={{ opacity: sort === field ? 1 : 0.35, fontSize: 10 }}>{sort === field ? (dir === "asc" ? "▲" : "▼") : "↕"}</span> : null}
            </th>
          ))}
        </tr>
      </thead>
    );
    if (!loaded) return null;
    if (!rows.length) {
      return (
        <div className="tt-tblwrap">
          <table className="tt-tbl">
            {head}
            <tbody>
              <tr>
                <td colSpan={COLUMNS.length} className="text-center text-secondary py-5" style={{ whiteSpace: "normal" }}>
                  <div style={{ fontSize: 30, opacity: 0.5 }}>{range_error ? "⚠" : "🗂"}</div>
                  <b>{range_error ? t("nsp_range_invalid") : t("nsp_empty_title")}</b>
                  <div className="tt-mini">{range_error || t("nsp_empty_hint")}</div>
                  <ClearFilterButton className="mt-2" onClick={this.ResetFilter} />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      );
    }
    return (
      <div className="tt-tblwrap">
        <table className="tt-tbl" style={{ minWidth: 1500 }}>
          {head}
          <tbody>
            {rows.map((r) => (
              <tr key={r.visit_uid} style={r.invoice_status === "pending" ? { background: "#FFFBF0" } : undefined}>
                <td className="tt-mono">{r.project_id || "-"}</td>
                <td>
                  <span
                    title={r.project_name}
                    style={{ display: "block", maxWidth: open_names[r.visit_uid] ? 380 : 300, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: open_names[r.visit_uid] ? "normal" : "nowrap", cursor: "pointer" }}
                    onClick={() => this.setState({ open_names: { ...open_names, [r.visit_uid]: !open_names[r.visit_uid] } })}
                  >
                    {r.project_name || "-"}
                  </span>
                </td>
                <td className="tt-mono">{r.customer_id || "-"}</td>
                <td>{r.customer_name || "-"}</td>
                <td>
                  <a href="#wo" className="tt-mono" onClick={(e) => { e.preventDefault(); this.setState({ detail: r }); }} data-testid="nsp-wo-link">{r.wo_number}</a>
                </td>
                <td><span className="tt-badge tt-b-in">{r.work_status}</span></td>
                <td>{this.renderTechnician(r)}</td>
                <td>{this.renderPay(r)}</td>
                <td className="num tt-mono" style={r.is_closing_line ? undefined : { color: "var(--tt-ink-soft)" }}>{money(r.amount)}</td>
                <td className="tt-mono">
                  {fmtDate(r.work_date)}
                  {r.day_count ? (
                    <span className={`tt-badge ms-1 ${r.is_closing_line ? "tt-b-in" : "tt-b-none"}`} title={t("nsp_multi_day_hint")}>
                      {t("nsp_day_badge").replace("{n}", r.day_index).replace("{m}", r.day_count)}
                    </span>
                  ) : null}
                </td>
                <td>{[r.department?.code, r.department?.name].filter(Boolean).join(" ") || "-"}</td>
                <td className="tt-mono">{r.so_no || "-"}</td>
                <td>{this.renderInvoice(r)}</td>
                <td>
                  {r.photo_count > 0 ? (
                    <button type="button" className="tt-btn tt-sm" onClick={() => this.OpenPhotos(r)} data-testid="nsp-photo-btn">
                      {t("nsp_photo_count").replace("{n}", r.photo_count)}
                    </button>
                  ) : (
                    <span className="text-secondary">-</span>
                  )}
                </td>
                <td>
                  <button
                    type="button"
                    className="tt-btn tt-sm"
                    disabled={!r.has_sr}
                    title={r.has_sr ? "" : t("service_report_unavailable")}
                    onClick={() => this.OpenServiceReport(r)}
                    data-testid="nsp-sr-btn"
                  >
                    {t("nsp_sr_open")}
                  </button>
                </td>
              </tr>
            ))}
            {summary ? (
              <tr className="tot">
                <td colSpan="8">{t("nsp_total_row").replace("{n}", formatNumber(summary.wo_count))} {count > size ? <span className="tt-mini">({t("nsp_all_pages")})</span> : null}</td>
                <td className="num tt-mono">{money(summary.amount)}</td>
                <td colSpan="6" />
              </tr>
            ) : null}
          </tbody>
        </table>
      </div>
    );
  }

  renderDrawer() {
    const { detail, rows } = this.state;
    if (!detail) return null;
    const lines = rows.filter((r) => r.wo_uid === detail.wo_uid);
    const kv = [
      [t("nsp_d_project"), <><b className="tt-mono">{detail.project_id || "-"}</b><br />{detail.project_name || "-"}</>],
      [t("nsp_d_customer"), `${detail.customer_id || "-"} · ${detail.customer_name || "-"}`],
      [t("nsp_col_technician"), (detail.technicians || []).join(", ") || "-"],
      [t("nsp_col_payment"), this.renderPay(detail)],
      [t("nsp_d_wo_total"), <b className="tt-mono">{money(detail.wo_total)}</b>],
      [t("nsp_d_so"), <span className="tt-mono">{detail.so_no || "-"}</span>],
      [t("nsp_d_invoice"), this.renderInvoice(detail)],
    ];
    if (detail.day_count) {
      kv.push([
        t("nsp_d_multi_day"),
        <>
          {lines.map((l) => (
            <div key={l.visit_uid} className="tt-mono">{fmtDate(l.work_date)} · {money(l.amount)}</div>
          ))}
          <b>{t("nsp_d_wo_total")} {money(detail.wo_total)}</b>
        </>,
      ]);
    }
    return (
      <Modal show onHide={() => this.setState({ detail: null })} centered scrollable contentClassName="border-0 rounded-4 shadow-lg" data-testid="nsp-drawer">
        <Modal.Header className="border-bottom border-light px-4 py-3 bg-white" closeButton>
          <div>
            <div className="d-flex align-items-center gap-2">
              <h5 className="fw-bold mb-0 text-dark">{detail.wo_number}</h5>
              <span className="tt-badge tt-b-in">{detail.work_status}</span>
            </div>
            <div className="tt-mini">{[detail.department?.code, detail.department?.name].filter(Boolean).join(" ") || "-"} · {t("nsp_d_work_date")} {fmtDate(detail.work_date)}</div>
          </div>
        </Modal.Header>
        <Modal.Body className="p-4 bg-white tt-page">
          <div className="tt-kv" style={{ gridTemplateColumns: "130px 1fr", background: "#F4F7FE", borderRadius: 12, padding: "12px 16px" }}>
            {kv.map(([label, value]) => (
              <React.Fragment key={label}>
                <span>{label}</span>
                <span>{value}</span>
              </React.Fragment>
            ))}
          </div>
        </Modal.Body>
        <Modal.Footer className="border-top border-light px-4 py-3 bg-white d-flex justify-content-end gap-2">
          <button type="button" className="btn btn-white border px-4 py-2 text-dark rounded-3 fw-bold" onClick={() => this.setState({ detail: null })}>{t("close")}</button>
          <a className="btn btn-primary px-4 py-2 rounded-3 fw-bold" href={`/ad/work-orders?search=${encodeURIComponent(detail.wo_number)}`} target="_blank" rel="noreferrer">↗ {t("nsp_open_wo")}</a>
        </Modal.Footer>
      </Modal>
    );
  }

  renderPhotoModal() {
    const { photo_modal } = this.state;
    if (!photo_modal) return null;
    const { row, loading: busy, photos, failed } = photo_modal;
    return (
      <Modal show onHide={this.ClosePhotos} centered size="lg" scrollable contentClassName="border-0 rounded-4 shadow-lg" data-testid="nsp-photo-modal">
        <Modal.Header className="border-bottom border-light px-4 py-3 bg-white" closeButton>
          <h5 className="fw-bold mb-0 text-dark">{t("nsp_photo_title")} <span className="tt-mono">{row.wo_number}</span> <span className="tt-mini fw-normal">{fmtDate(row.work_date)}</span></h5>
        </Modal.Header>
        <Modal.Body className="p-4 bg-white tt-page">
          {busy ? <div className="tt-mini py-4 text-center">{t("loading")}</div> : null}
          {!busy && !photos.length ? <div className="tt-mini py-4 text-center">{t("nsp_photo_empty")}</div> : null}
          {!busy && failed ? <div className="tt-mini mb-2" style={{ color: "var(--tt-crit)" }}>{t("nsp_photo_load_failed").replace("{n}", failed)}</div> : null}
          {PHOTO_STAGES.map((stage) => {
            const list = photos.filter((p) => p.stage === stage);
            if (!list.length) return null;
            return (
              <div key={stage} className="mb-3">
                <b>{t(`nsp_photo_stage_${stage}`)}</b> <span className="tt-mini">({formatNumber(list.length)})</span>
                <div className="d-flex flex-wrap gap-2 mt-1">
                  {list.map((p) =>
                    p.url ? (
                      <a key={p.uid} href={p.url} target="_blank" rel="noreferrer" title={p.file_name}>
                        <img src={p.url} alt={p.file_name} style={{ width: 150, height: 150, objectFit: "cover", borderRadius: 8, border: "1px solid #E3E8F2" }} />
                      </a>
                    ) : (
                      <div key={p.uid} className="tt-mini d-flex align-items-center justify-content-center" style={{ width: 150, height: 150, borderRadius: 8, border: "1px dashed #E3E8F2" }}>!</div>
                    )
                  )}
                </div>
              </div>
            );
          })}
        </Modal.Body>
        <Modal.Footer className="border-top border-light px-4 py-3 bg-white d-flex justify-content-end">
          <button type="button" className="btn btn-white border px-4 py-2 text-dark rounded-3 fw-bold" onClick={this.ClosePhotos}>{t("close")}</button>
        </Modal.Footer>
      </Modal>
    );
  }

  renderExportModal() {
    const { export_open, export_summary, filter_from, filter_to, filter_department, filter_pay, filter_technician, filter_q, technicians, department_options, locked_bu, summary } = this.state;
    if (!export_open || !summary) return null;
    const tech = technicians.find((x) => x.uid === filter_technician);
    const dept = department_options.find((d) => d.uid === filter_department);
    const filters = [
      locked_bu && `BU ${locked_bu}`,
      dept && `${t("department")} ${this.departmentLabel(dept)}`,
      filter_pay && this.payLabel(filter_pay),
      tech && `${t("nsp_technician")} ${tech.name}`,
      filter_q.trim() && `${t("search")} "${filter_q.trim()}"`,
    ].filter(Boolean).join(" · ") || t("nsp_no_filter");
    const kv = [
      [t("nsp_range"), `${fmtDate(filter_from)} – ${fmtDate(filter_to)}`],
      [t("nsp_filters"), filters],
      [t("nsp_export_rows"), `${summary.line_count} ${t("nsp_lines")} (${summary.wo_count} ${t("nsp_jobs")})`],
      [t("nsp_shown_total"), <b className="tt-mono">{money(summary.amount)}</b>],
      [t("nsp_export_file"), <span className="tt-mono">{`NormalSales_Payment_${stamp(filter_from)}-${stamp(filter_to)}.xlsx`}</span>],
    ];
    return (
      <Modal show onHide={() => this.setState({ export_open: false })} centered contentClassName="border-0 rounded-4 shadow-lg" data-testid="nsp-export-modal">
        <Modal.Header className="border-bottom border-light px-4 py-3 bg-white" closeButton>
          <h5 className="fw-bold mb-0 text-dark">⬇ {t("nsp_export_title")}</h5>
        </Modal.Header>
        <Modal.Body className="p-4 bg-white tt-page">
          <div className="tt-mini">{t("nsp_export_desc")}</div>
          <div className="tt-kv" style={{ gridTemplateColumns: "130px 1fr", background: "#F4F7FE", borderRadius: 12, padding: "12px 16px", margin: "12px 0" }}>
            {kv.map(([label, value]) => (
              <React.Fragment key={label}>
                <span>{label}</span>
                <span>{value}</span>
              </React.Fragment>
            ))}
          </div>
          <label className="d-flex align-items-start gap-2 mb-2" style={{ cursor: "pointer" }}>
            <input type="checkbox" className="mt-1" checked={export_summary} onChange={(e) => this.setState({ export_summary: e.target.checked })} />
            <span>{t("nsp_export_sheet_summary")}</span>
          </label>
        </Modal.Body>
        <Modal.Footer className="border-top border-light px-4 py-3 bg-white d-flex justify-content-end gap-2">
          <button type="button" className="btn btn-white border px-4 py-2 text-dark rounded-3 fw-bold" onClick={() => this.setState({ export_open: false })}>{t("cancel")}</button>
          <button type="button" className="btn btn-primary px-4 py-2 rounded-3 fw-bold" onClick={this.Export} data-testid="nsp-export-confirm">{t("nsp_export_download")}</button>
        </Modal.Footer>
      </Modal>
    );
  }

  render() {
    const { filter_from, filter_to, filter_department, filter_pay, filter_technician, filter_q, preset, department_options, locked_bu, technicians, as_of, range_error, count, page, size, rows, summary } = this.state;
    const presets = ["today", "yest", "week", "month"];
    const bad = range_error ? { borderColor: "var(--tt-crit)", background: "var(--tt-crit-soft)" } : undefined;

    return (
      <div className="w-100 min-vh-100" style={{ backgroundColor: "#F4F7FE" }}>
        <NavbarAdmin />
        <div className="body p-4 mt-3 tt-page">
          <div className="d-flex flex-wrap justify-content-between align-items-center mb-4 gap-3">
            <div>
              <h3 className="fw-bold mb-1 text-dark">{t("nsp_title")}</h3>
              <div className="text-secondary text-14">{t("nsp_as_of")} <span className="tt-mono">{as_of}</span></div>
            </div>
            <div className="d-flex gap-2">
              <button className="btn btn-white border px-3 py-2 fw-bold rounded-3" onClick={() => this.Get(page)} data-testid="nsp-refresh-btn">⟳ {t("nsp_refresh")}</button>
              {this.canExport ? (
                <button className="btn btn-white border px-3 py-2 fw-bold rounded-3" onClick={this.OpenExport} disabled={!summary || !summary.line_count} data-testid="nsp-export-btn">⬇ {t("att_export_btn")}</button>
              ) : null}
            </div>
          </div>

          <div className="bg-white rounded-4 shadow-sm p-4 mb-4">
            <div className="row g-3 align-items-end">
              <div className="col-md-4">
                <label className="form-label text-12 text-secondary mb-1">{t("date_range")}</label>
                <div className="d-flex gap-2">
                  <DateRangeFields
                    type="th"
                    className="form-control"
                    fieldStyle={{ flex: 1, minWidth: 0 }}
                    startPlaceholder={t("start_date")}
                    endPlaceholder={t("end_date")}
                    startValue={filter_from}
                    endValue={filter_to}
                    style={bad}
                    onChange={({ start, end }) => this.SetFilter({ filter_from: start, filter_to: end, preset: "" })}
                  />
                </div>
              </div>
              <div className="col-md-2" data-testid="nsp-filter-department">
                <label className="form-label text-12 text-secondary mb-1">{t("department")}</label>
                <Select
                  className="form-control w-100"
                  options={[{ value: "", label: t("all") }, ...department_options.map((d) => ({ value: d.uid, label: this.departmentLabel(d) }))]}
                  value={filter_department}
                  onChange={(v) => this.SetFilter({ filter_department: v || "" })}
                  placeholder={t("all")}
                />
                {locked_bu ? <div className="tt-mini mt-1" data-testid="nsp-locked-bu">BU {locked_bu}</div> : null}
              </div>
              <div className="col-md-2" data-testid="nsp-filter-pay">
                <label className="form-label text-12 text-secondary mb-1">{t("nsp_col_payment")}</label>
                <Select
                  className="form-control w-100"
                  options={[{ value: "", label: t("all") }, ...PAYMENTS.map((p) => ({ value: p.key, label: this.payLabel(p.key) }))]}
                  value={filter_pay}
                  onChange={(v) => this.SetFilter({ filter_pay: v || "" })}
                  placeholder={t("all")}
                />
              </div>
              <div className="col-md-2">
                <label className="form-label text-12 text-secondary mb-1">{t("nsp_technician")}</label>
                <Select
                  className="form-control w-100"
                  options={[{ value: "", label: t("all") }, ...technicians.map((x) => ({ value: x.uid, label: x.name }))]}
                  value={filter_technician}
                  onChange={(v) => this.SetFilter({ filter_technician: v || "" })}
                  placeholder={t("all")}
                />
              </div>
              <div className="col-md-2">
                <label className="form-label text-12 text-secondary mb-1">{t("nsp_search")}</label>
                <input className="form-control" value={filter_q} placeholder={t("nsp_search_ph")} onChange={(e) => this.SetQ(e.target.value)} />
              </div>
              <div className="col-12 d-flex justify-content-end">
                <ClearFilterButton onClick={this.ResetFilter} />
              </div>
              {range_error ? <div className="col-12 text-12" style={{ color: "var(--tt-crit)" }} data-testid="nsp-range-error">{range_error}</div> : null}
            </div>
          </div>

          <div className="d-flex align-items-center flex-wrap gap-2 mb-2">
            <div className="tt-seg">
              {presets.map((p) => (
                <button key={p} type="button" className={preset === p ? "on" : ""} onClick={() => this.ApplyPreset(p)}>{t(`nsp_preset_${p}`)}</button>
              ))}
            </div>
            <span className="tt-mini">{t("ts_max_range")}</span>
          </div>

          {this.renderKpi()}

          {summary && summary.line_count ? (
            <div className="tt-mini mb-2 d-flex gap-3 flex-wrap">
              <span>{t("nsp_range")} <b>{fmtDate(filter_from)}</b>{filter_from !== filter_to ? <> – <b>{fmtDate(filter_to)}</b></> : null}</span>
              <span>{t("nsp_shown")} <b>{formatNumber(summary.wo_count)}</b> {t("nsp_jobs")} (<b>{formatNumber(summary.line_count)}</b> {t("nsp_lines")})</span>
              <span>{t("nsp_shown_total")} <b className="tt-mono">{money(summary.amount)}</b></span>
              {filter_pay ? (
                <span className="tt-badge tt-b-in" style={{ cursor: "pointer" }} onClick={() => this.TogglePay(filter_pay)}>{t("nsp_filter_badge")}: {this.payLabel(filter_pay)} ✕</span>
              ) : null}
            </div>
          ) : null}

          {this.renderRows()}

          {rows.length ? (
            <div className="d-flex justify-content-between align-items-center mt-3 flex-wrap tt-mini">
              <div>
                {t("showing")} {formatNumber((page - 1) * size + 1)}-{formatNumber((page - 1) * size + rows.length)} {t("of")} {formatNumber(count)} ·{" "}
                <select
                  value={size}
                  style={{ width: "auto", padding: "2px 6px" }}
                  onChange={(e) => this.setState({ size: Number(e.target.value) }, () => this.Get(1))}
                >
                  {PAGE_SIZES.map((n) => <option key={n} value={n}>{n}</option>)}
                </select>{" "}
                / {t("nsp_per_page")}
              </div>
              <Pagination className="mb-0" count={Math.ceil(count / size) || 1} page={page} showFirstButton={false} showLastButton={false} onChange={(_, next) => this.Get(next)} />
            </div>
          ) : null}

          {this.renderDrawer()}
          {this.renderExportModal()}
          {this.renderPhotoModal()}
        </div>
      </div>
    );
  }
}
